import { Skeleton } from "@/components/ui";

/**
 * Skeleton loading state for chat message list.
 * Mirrors MessageList layout with alternating user (right) and AI (left) placeholder bubbles.
 * Use when connecting to a thread and fetching thread history.
 */
export function MessageListSkeleton() {
  const rows = [
    { side: "ai" as const, width: "w-3/4" },
    { side: "user" as const, width: "w-1/3" },
    { side: "ai" as const, width: "w-4/5" },
    { side: "user" as const, width: "w-2/5" },
  ];

  return (
    <div className="min-h-full p-4 md:p-6">
      {rows.map((row, index) => (
        <div
          key={index}
          className={`mb-6 flex ${row.side === "user" ? "justify-end" : "justify-start"}`}
        >
          {row.side === "ai" ? (
            <div className="flex w-full flex-col">
              <Skeleton className={`h-20 rounded-2xl ${row.width}`} />
            </div>
          ) : (
            <div className="flex items-start gap-2">
              <Skeleton className={`h-16 rounded-2xl border border-primary/20 bg-primary/10 ${row.width}`} />
              <Skeleton className="h-8 w-8 flex-shrink-0 rounded-full" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
